import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import setSettingsValueOperation from 'editor/src/store/editor/operation/setSettingsValueOperation';
import getSettingsValue from 'editor/src/store/editor/selector/getSettingsValue';
import { SettingsProperty, Unit } from 'editor/src/store/editor/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import SettingsItem from 'editor/src/component/DesktopSidebar/TabContents/SettingsTabContent/SettingsItem';
import SelectButtonGroup from 'editor/src/component/SelectButtonGroup';

import settingsItemStyles from 'editor/src/component/DesktopSidebar/TabContents/SettingsTabContent/SettingsItem/index.module.scss';

function UnitsSelector() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const unit = useSelector((state) => getSettingsValue(state, SettingsProperty.units));

  const options: Array<{ label: string; value: Unit }> = useMemo(
    () => [
      { label: t('editor-cm'), value: 'cm' },
      { label: t('editor-inch'), value: 'inch' },
    ],
    [],
  );

  const handleChange = useCallback((value: Unit) => {
    dispatch(setSettingsValueOperation(SettingsProperty.units, value));
  }, []);

  return (
    <SettingsItem>
      {/* TODO: Lokalino */}
      <div className={settingsItemStyles.title}>Units</div>
      <SelectButtonGroup items={options} value={unit} onChange={handleChange} className="cy-settings-units" />
    </SettingsItem>
  );
}

export default React.memo(UnitsSelector);
